define('shared/initializer/form/adapters/mixins/fields/CCV',[
    'shared/page/wcmmode',
    'shared/lib/beam',
    'shared/util/modeDetector',
    'shared/lib/RSVP',
    '$'
], function (
    getWCMMode, beam, modeDetector, RSVP, $
) {
    'use strict';

    function picturefillRefresh() {
        $(window).trigger('picturefill.refresh');
    }

    function getParams($popoverContent) {
        var content = $popoverContent.css('content');
        content = content.replace(/['"]/g, '');
        var paramArray = content.split('|');
        var ret = {};
        for(var i = paramArray.length; i--;) {
            ret[paramArray[i]] = true;
        }
        return ret;
    }

    function Ctor () {
    }

    var p = Ctor.prototype;

    p.doPageLoad = function() {
        var me = this;

        return RSVP.all([getWCMMode(), modeDetector.mode()])
            .then(function(values) {
                var wcmmode = values[0];
                var rspnMode = values[1];

                if (wcmmode.toLowerCase() === 'edit') {
                    return;
                }

                var $form = me.$form;
                var $input = $form.find('.form-group-CardVerificationCode input');
                var $iconWrap = $form.find('.icon-wrap.icon-wrap--trigger-popover');
                var $triggerIcon = $iconWrap.find('.icon');
                var $popoverContent = $form.find('.popover-content-placeholder').eq(0);
                var $arrow = $('<div class="arrow"></div>');

                modeDetector.on('change', function(value){
                    rspnMode = value;
                });

                function showPopup(){
                    var $toTarget = $triggerIcon;
                    var atParam, offset;

                    if (rspnMode === 'desktop') {
                        atParam = 'outer right top';
                        offset = {
                            inline: 10
                        };
                    }
                    else {
                        atParam = 'outer top right';
                        offset = {
                            block: -10,
                            inline: 10
                        };
                    }

                    if ($toTarget.length <= 0) {
                        $toTarget = $input;
                        atParam = 'outer top center';
                        offset = null;
                    }

                    $popoverContent.css({
                        'transition': 'none',
                        'transform': 'none'
                    });

                    $popoverContent
                        .show()
                        .beam()
                            .to($input)
                            .at(atParam, offset)
                            .end();

                    var params = getParams($popoverContent);

                    if (params['use-js-arrow'] && $triggerIcon.length > 0) {
                        $popoverContent.append($arrow);

                        if (rspnMode === 'desktop') {
                            $arrow
                                .beam()
                                    .to($triggerIcon)
                                    .at('middle')
                                    .end()
                                .css({
                                    left: ''
                                });
                        }
                        else {
                            $arrow
                                .beam()
                                    .to($triggerIcon)
                                    .at('center')
                                    .end()
                                .css({
                                    top: ''
                                });
                        }
                    }

                    $popoverContent.css({
                        'transform': ''
                    });

                    if (params['use-css-animation']) {
                        setTimeout(function(){
                            $popoverContent.css({
                                'transition': ''
                            });
                            $popoverContent.addClass('active');
                        });
                    }
                    else {
                        $popoverContent.hide().fadeIn();
                    }

                    picturefillRefresh();
                }

                function hidePopup(){
                    var params = getParams($popoverContent);

                    if (params['use-css-animation']) {
                        $popoverContent
                            .removeClass('active')
                            .one('transitionend', function(){
                                if ($popoverContent.hasClass('active')) {
                                    return;
                                }
                                $popoverContent.hide();
                            });
                    }
                    else {
                        $popoverContent.fadeOut();
                    }
                }

                if ($triggerIcon.length > 0) {
                    $triggerIcon.on('click', showPopup);
                    $('html').on('click', function(evt){
                        var $target = $(evt.target);

                        if (
                            $target[0] === $iconWrap[0] ||
                            $target[0] === $popoverContent[0] ||
                            $target.closest($iconWrap).length > 0 || 
                            $target.closest($popoverContent).length > 0) {
                            return;
                        }

                        hidePopup();
                    });
                }
                else {
                    $input.on('focus', showPopup);
                    $input.on('blur', hidePopup);
                }

                picturefillRefresh();
            });
    };

    return Ctor;
});
